// eslint-disable-next-line no-unused-vars
import React, { useState, memo, useRef, useEffect } from 'react';
import { bool, func, array } from 'prop-types';

import useOutsideClick from 'Hooks/useOutsideClick';
import ExchangeRateComponent from 'Components/SettingsBar/ExchangeRate';

const ExchangeRate = memo(({
  exchangeRates,
  exchangeRatesLoading,
  formatNumber,
  t,
}) => {
  const exchangeRateRef = useRef(null);
  const isExchangeRateVisible = useOutsideClick(exchangeRateRef);
  const [menuOpen, openMenu] = useState(false);

  useEffect(() => {
    openMenu(isExchangeRateVisible);
  }, [isExchangeRateVisible]);

  const onClick = () => openMenu(prevState => !prevState);

  return (
    <ExchangeRateComponent
      ref={ exchangeRateRef }
      menuOpen={ menuOpen }
      onToggle={ onClick }
      exchangeRates={ exchangeRates }
      exchangeRatesLoading={ exchangeRatesLoading }
      formatNumber={ formatNumber }
      t={ t }
    />
  );
});

ExchangeRate.propTypes = {
  exchangeRates: array,
  exchangeRatesLoading: bool.isRequired,
  formatNumber: func.isRequired,
  t: func.isRequired,
};

ExchangeRate.displayName = 'ExchangeRateContainer';

export default ExchangeRate;
